import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { useRolePermissions } from '../../../../../hooks/useRolePermissions';
import { closeAnimated } from '../../../../../redux/actions/sideDrawerActions';
import CustomButton from '../../../../shared/atoms/CustomButton';
import * as S from './style';
import DnDAsset from '../DnDAsset';
import CustomLabel from '../../../../shared/atoms/CustomLabel';
import { useAssetFormContext } from '../../../../../context/AssetFormContext';

const DnDAssetsList = ({ didDrop, editing, popPage, disabled, iconElRef }) => {
  const history = useHistory();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { data: userPermissions } = useRolePermissions();
  const { setLocation } = useAssetFormContext();
  const dispatch = useDispatch();
  const closeAnimatedAction = () => dispatch(closeAnimated());

  const hasAsset = editing.assets.some(a => !a.is_placed);

  return (
    <Stack>
      <CustomLabel>{t('tools_menu.location.assets')}</CustomLabel>
      <S.DnDAssetsList>
        <Typography sx={{ whiteSpace: 'break-spaces' }} gutterBottom>
          {hasAsset
            ? t('tools_menu.location.drag_n_drop')
            : t('tools_menu.location.click_or_add')}
        </Typography>
        <S.NewAssetBtn>
          <Box sx={{ overflow: 'auto' }}>
            {editing.assets
              .filter(a => !a.is_placed)
              .sort((a, b) =>
                a.name.localeCompare(b.name, i18n.language, { numeric: true }),
              )
              .map(asset => (
                <DnDAsset
                  key={asset.name}
                  asset={asset}
                  didDrop={didDrop}
                  disabled={disabled}
                />
              ))}
          </Box>
          {userPermissions?.management?.assets?.manage && (
            <CustomButton
              style={{ width: '100%' }}
              disabled={disabled}
              onClick={e => {
                e.preventDefault();
                e.target.blur();
                setLocation(editing);
                history.push({
                  pathname: '/portal/management/assets/new',
                  search: location.search,
                });
                popPage();
                closeAnimatedAction();
              }}
            >
              {t('tools_menu.location.add_new_asset')}
            </CustomButton>
          )}
        </S.NewAssetBtn>
      </S.DnDAssetsList>
      {editing.assets
        .filter(a => a.is_placed && iconElRef.current.get(a.id))
        .map(a => iconElRef.current.get(a.id))}
    </Stack>
  );
};

DnDAssetsList.propTypes = {
  didDrop: PropTypes.func.isRequired,
  editing: PropTypes.object.isRequired,
  iconElRef: PropTypes.object.isRequired,
  popPage: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default DnDAssetsList;
